module.exports = __webpack_public_path__ + "static/app/img/logo.f84ac5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo.png
// module id = KItN
// module chunks = 1